// Bilingual UI strings for DevTask. Keys are dotted paths, resolved by t() in useI18n.
export const messages = {
  he: {
    common: {
      save: 'שמירה', saveChanges: 'שמירת שינויים', create: 'יצירה', cancel: 'ביטול',
      saving: 'שומר…', edit: 'עריכה', reset: 'איפוס', search: 'חיפוש…',
      all: 'הכל', none: '— ללא —', viewAll: 'הצג הכל', loading: 'טוען…',
      from: 'מתאריך', to: 'עד תאריך', export: 'ייצוא CSV',
    },
    search: {
      title: 'תוצאות חיפוש', for: 'עבור', tasks: 'משימות', projects: 'פרויקטים',
      clients: 'לקוחות', noResults: 'לא נמצאו תוצאות עבור', empty: 'הקלד מונח לחיפוש.',
    },
    nav: {
      dashboard: 'לוח בקרה', myTasks: 'המשימות שלי', teamTasks: 'משימות צוות',
      projects: 'פרויקטים', team: 'הצוות', archive: 'ארכיון', clients: 'לקוחות', signOut: 'התנתקות',
      requests: 'בקשות',
      language: 'English', theme: 'מצב תצוגה', collapse: 'כווץ תפריט',
    },
    portal: {
      navOverview: 'סקירה', navProjects: 'הפרויקטים שלי', navRequests: 'בקשות', navReports: 'דוחות וחיוב',
      dashSub: 'מבט על הפרויקטים, ההתקדמות והחיוב שלך',
      requestWork: 'בקשת עבודה', activeProjects: 'פרויקטים פעילים', openRequests: 'בקשות פתוחות',
      hoursTracked: 'שעות שנמדדו', estBilling: 'חיוב משוער', yourProjects: 'הפרויקטים שלך',
      noProjects: 'אין עדיין פרויקטים.', openTasks: 'משימות פתוחות', noPricing: 'ללא תמחור',
      billingModel: 'מודל חיוב', tasks: 'משימות', noTasks: 'אין עדיין משימות בפרויקט.',
    },
    requests: {
      pending: 'ממתין', approved: 'אושר', declined: 'נדחה',
      typeProject: 'פרויקט חדש', typeTask: 'משימה',
      myTitle: 'הבקשות שלי', mySub: 'בקש פרויקט או משימה חדשה מהצוות',
      newBtn: 'בקשה חדשה', fieldTitle: 'כותרת', titlePh: 'מה תרצה?', fieldDesc: 'פירוט',
      descPh: 'תאר את הבקשה…', fieldProject: 'פרויקט', selectProject: '— בחר פרויקט —',
      billingPref: 'העדפת חיוב', amount: 'סכום מבוקש', submit: 'שלח בקשה',
      empty: 'עדיין לא שלחת בקשות.',
      inboxTitle: 'בקשות לקוחות', inboxSub: 'אשר, ערוך או דחה בקשות עבודה מלקוחות',
      inboxEmpty: 'אין בקשות.', from: 'מאת', billingWanted: 'חיוב מבוקש', reviewed: 'טופלו',
      approve: 'אשר', decline: 'דחה', declineConfirm: 'לדחות את הבקשה "{title}"?',
      deadline: 'יעד', revised: 'הוצעו שינויים',
      revise: 'הצע שינויים', reviseTitle: 'עריכת הבקשה', sendRevision: 'שלח ללקוח',
      awaitingClient: 'ממתין ללקוח', revisedSent: 'נשלחה הצעה ללקוח',
      teamRevised: 'הצוות הציע שינויים לבקשה. ניתן לאשר או להציע משהו אחר.',
      counter: 'הצע משהו אחר', acceptRevision: 'אשר', sendCounter: 'שלח בקשה מעודכנת',
    },
    reports: {
      sub: 'שעות, התקדמות וחיוב לפי פרויקט', allProjects: 'כל הפרויקטים',
      tasksDone: 'משימות שהושלמו', subtasksDone: 'תת-משימות שהושלמו', totalDue: 'סך לתשלום',
      hoursPerTask: 'שעות לפי משימה', subtasksChart: 'התקדמות תת-משימות', billingPerProject: 'חיוב לפי פרויקט',
      done: 'הושלמו', remaining: 'נותרו', noData: 'אין נתונים עדיין.',
    },
    activity: { title: 'פעילות צוות', idle: 'לא פעיל', none: 'אין מפתחים' },
    roles: { client: 'לקוח', manager: 'מנהל', developer: 'מפתח' },
    login: {
      title: 'התחברות למרחב העבודה',
      sub: 'אין לך חשבון? פנה למנהל כדי לקבל גישה.',
      identifier: 'אימייל או שם משתמש',
      identifierPlaceholder: 'you@company.com או שם המשתמש שלך',
      password: 'סיסמה',
      signIn: 'התחברות',
      signingIn: 'מתחבר…',
      failed: 'ההתחברות נכשלה',
    },
    dashboard: {
      morning: 'בוקר טוב', afternoon: 'צהריים טובים', evening: 'ערב טוב',
      there: 'שלום',
      sub: 'הנה מה שעל הפרק היום',
      newTask: 'משימה חדשה',
      open: 'פתוחות', inProgress: 'בתהליך', done: 'הושלמו', critical: 'דחופות',
      recentTasks: 'משימות אחרונות',
      empty: 'אין משימות עדיין. צור את הראשונה!',
      projects: 'פרויקטים', myTasks: 'המשימות שלי',
      noProjects: 'אין פרויקטים עדיין.',
      subtasksWidget: 'תת-משימות', commentsWidget: 'תגובות אחרונות',
      noSubtasks: 'אין תת-משימות עדיין.', noComments: 'אין תגובות עדיין.', noRequests: 'אין בקשות ממתינות.',
      dragHint: 'גרור כדי לסדר מחדש את הווידג׳טים', addWidget: 'הוסף ווידג׳ט', hideWidget: 'הסתר ווידג׳ט',
      noWidgets: 'כל הווידג׳טים מוסתרים. הוסף אחד מלמעלה.',
      paneEmpty: 'אין משימות להצגה.',
      progress: 'התקדמות', allDone: 'הכל הושלם',
      newInProject: 'משימה בפרויקט', selectHint: 'בחר פרויקט כדי לראות את המשימות שלו',
    },
    tasks: {
      myTitle: 'המשימות שלי', teamTitle: 'משימות צוות',
      mySub: 'משימות שהוקצו לך או שיצרת', teamSub: 'כל המשימות הגלויות לצוות שלך',
      newTask: 'משימה חדשה',
      allUrgency: 'כל הדחיפויות', allProjects: 'כל הפרויקטים',
      empty: 'לא נמצאו משימות.',
      archiveConfirm: 'להעביר את "{title}" לארכיון?',
    },
    taskForm: {
      newTask: 'משימה חדשה', editTask: 'עריכת משימה',
      title: 'כותרת', titlePlaceholder: 'כותרת המשימה',
      description: 'תיאור', descriptionPlaceholder: 'פרטים נוספים…',
      urgency: 'דחיפות', status: 'סטטוס', project: 'פרויקט', dueDate: 'תאריך יעד',
      visibility: 'נראות',
      shared: '🌐 משותף (הצוות רואה)', private: '🔒 פרטי (רק אתה + המוקצה)',
      assignTo: 'הקצה ל', unassigned: '— לא מוקצה —',
      linkClient: 'קישור ללקוח',
      privateProjectLock: 'משימות בפרויקט פרטי הן תמיד פרטיות וגלויות רק לחברי הפרויקט',
      createTask: 'צור משימה', saveFailed: 'השמירה נכשלה',
    },
    taskCard: { private: 'פרטי', markDone: 'סמן כהושלם', reopen: 'פתח מחדש', archive: 'ארכיון' },
    subtasks: {
      toggle: 'תת-משימות', titleCol: 'תת-משימה', titlePlaceholder: 'שם תת-המשימה',
      col: 'עמודה', addColumn: 'הוסף עמודה', removeColumn: 'מחק עמודה', newColumn: 'עמודה חדשה',
      removeColumnConfirm: 'למחוק את העמודה "{label}"?',
      addRow: 'הוסף', removeRow: 'מחק', addPlaceholder: 'תת-משימה חדשה…', empty: 'אין עדיין תת-משימות',
    },
    comments: {
      title: 'תגובות', empty: 'אין תגובות עדיין',
      placeholder: 'כתוב תגובה…', send: 'שלח', closed: 'המשימה הושלמה — לא ניתן להוסיף תגובות.',
    },
    export: {
      task: 'משימה', project: 'פרויקט', assignee: 'אחראי',
      status: 'סטטוס', urgency: 'דחיפות', hours: 'שעות', due: 'תאריך יעד',
    },
    timer: { start: 'הפעל טיימר', stop: 'עצור טיימר', running: 'פועל כעת' },
    urgency: { low: 'נמוכה', normal: 'רגילה', high: 'גבוהה', critical: 'דחופה' },
    status: { open: 'פתוחה', in_progress: 'בתהליך', done: 'הושלמה' },
    projects: {
      title: 'פרויקטים', newProject: 'פרויקט חדש', editProject: 'עריכת פרויקט',
      empty: 'אין פרויקטים עדיין.',
      name: 'שם', description: 'תיאור', color: 'צבע', visibility: 'נראות',
      shared: 'משותף (הצוות רואה)', private: 'פרטי (רק אתה)',
      sharedBadge: 'משותף', privateBadge: 'פרטי',
      taskCountOne: 'משימה פתוחה אחת', taskCountMany: 'משימות פתוחות',
      noTasks: 'אין משימות בפרויקט', dragHint: 'גרור כדי לסדר או להעביר בין פרויקטים',
      viewTasks: 'הצג משימות', archiveTitle: 'העבר פרויקט לארכיון',
      archiveConfirm: 'להעביר את הפרויקט "{name}" לארכיון?',
      members: 'חברי הפרויקט', addMember: 'הוסף', remove: 'הסר',
      noMembers: 'אין חברים עדיין', selectUser: '— בחר משתמש —',
      membersHint: 'חברים יכולים לראות את הפרויקט וליצור בו משימות',
      saveFirst: 'שמור את הפרויקט תחילה כדי להוסיף חברים',
      pricing: 'תמחור', pricingNone: 'ללא תמחור', pricingFixed: 'מחיר קבוע', pricingHourly: 'לפי שעה',
      ratePlaceholder: 'תעריף לשעה', totalPlaceholder: 'מחיר כולל',
      clients: 'לקוחות הפרויקט', clientsHint: 'לקוחות שהוקצו רואים את המשימות והשעות של הפרויקט',
      noClients: 'לא הוקצו לקוחות', selectClient: '— בחר לקוח —', addClientBtn: 'הוסף',
    },
    archive: {
      title: 'ארכיון', sub: 'כל המשימות בארכיון — שום דבר לא נמחק לצמיתות',
      tasks: 'משימות', projects: 'פרויקטים',
      noTasks: 'אין משימות בארכיון.', noProjects: 'אין פרויקטים בארכיון.',
      archivedOn: 'הועבר לארכיון',
      restore: 'שחזור', restoreConfirm: 'לשחזר את "{title}" מהארכיון?',
    },
    teamPage: {
      title: 'הצוות', sub: 'המפתחים והפרויקטים המשותפים בארגון',
      developers: 'מפתחים', projects: 'פרויקטים משותפים',
      noProjects: 'אין פרויקטים משותפים', tasksCount: 'משימות פתוחות',
    },
    clients: {
      title: 'לקוחות', sub: 'לקוחות חיצוניים שיכולים לצפות במשימות ששותפו איתם',
      addClient: 'הוסף לקוח', editClient: 'עריכת לקוח',
      name: 'שם', username: 'שם משתמש', status: 'סטטוס', projects: 'פרויקטים',
      searchPh: 'חיפוש לפי שם או פרויקט…',
      active: 'פעיל', inactive: 'לא פעיל',
      activate: 'הפעל', deactivate: 'השבת',
      empty: 'אין לקוחות חיצוניים עדיין.',
      fullName: 'שם מלא', usernamePlaceholder: 'ללא רווחים, משמש להתחברות',
      newPassword: 'סיסמה חדשה (השאר ריק לשמירה)', passwordLabel: 'סיסמה',
      passwordPlaceholder: 'לפחות 8 תווים',
      toggleConfirm: '{verb} את {name}?',
    },
  },
  en: {
    common: {
      save: 'Save', saveChanges: 'Save changes', create: 'Create', cancel: 'Cancel',
      saving: 'Saving…', edit: 'Edit', reset: 'Reset', search: 'Search…',
      all: 'All', none: '— None —', viewAll: 'View all', loading: 'Loading…',
      from: 'From', to: 'To', export: 'Export CSV',
    },
    search: {
      title: 'Search results', for: 'for', tasks: 'Tasks', projects: 'Projects',
      clients: 'Clients', noResults: 'No results for', empty: 'Type a term to search.',
    },
    nav: {
      dashboard: 'Dashboard', myTasks: 'My Tasks', teamTasks: 'Team Tasks',
      projects: 'Projects', team: 'Team', archive: 'Archive', clients: 'Clients', signOut: 'Sign out',
      requests: 'Requests',
      language: 'עברית', theme: 'Theme', collapse: 'Collapse menu',
    },
    portal: {
      navOverview: 'Overview', navProjects: 'My Projects', navRequests: 'Requests', navReports: 'Reports & Billing',
      dashSub: 'A look at your projects, progress and billing',
      requestWork: 'Request work', activeProjects: 'Active projects', openRequests: 'Open requests',
      hoursTracked: 'Hours tracked', estBilling: 'Estimated billing', yourProjects: 'Your projects',
      noProjects: 'No projects yet.', openTasks: 'open tasks', noPricing: 'No pricing',
      billingModel: 'Billing model', tasks: 'Tasks', noTasks: 'No tasks in this project yet.',
    },
    requests: {
      pending: 'Pending', approved: 'Approved', declined: 'Declined',
      typeProject: 'New project', typeTask: 'Task',
      myTitle: 'My Requests', mySub: 'Ask the team for a new project or task',
      newBtn: 'New request', fieldTitle: 'Title', titlePh: 'What do you need?', fieldDesc: 'Details',
      descPh: 'Describe your request…', fieldProject: 'Project', selectProject: '— Select project —',
      billingPref: 'Billing preference', amount: 'Proposed amount', submit: 'Submit request',
      empty: "You haven't submitted any requests yet.",
      inboxTitle: 'Client Requests', inboxSub: 'Approve, edit or decline client work requests',
      inboxEmpty: 'No requests.', from: 'from', billingWanted: 'Requested billing', reviewed: 'Reviewed',
      approve: 'Approve', decline: 'Decline', declineConfirm: 'Decline the request “{title}”?',
      deadline: 'Deadline', revised: 'Changes proposed',
      revise: 'Propose changes', reviseTitle: 'Edit request', sendRevision: 'Send to client',
      awaitingClient: 'Awaiting client', revisedSent: 'Revision sent to client',
      teamRevised: 'The team proposed changes to your request. Accept them, or ask for something else.',
      counter: 'Ask for changes', acceptRevision: 'Accept', sendCounter: 'Send updated request',
    },
    reports: {
      sub: 'Hours, progress and billing by project', allProjects: 'All projects',
      tasksDone: 'Tasks done', subtasksDone: 'Subtasks done', totalDue: 'Total due',
      hoursPerTask: 'Hours per task', subtasksChart: 'Subtask progress', billingPerProject: 'Billing per project',
      done: 'Done', remaining: 'Remaining', noData: 'No data yet.',
    },
    activity: { title: 'Team activity', idle: 'Idle', none: 'No developers' },
    roles: { client: 'Client', manager: 'Manager', developer: 'Developer' },
    login: {
      title: 'Sign in to your workspace',
      sub: 'No account? Contact your manager to get access.',
      identifier: 'Email or username',
      identifierPlaceholder: 'you@company.com or your.username',
      password: 'Password',
      signIn: 'Sign in',
      signingIn: 'Signing in…',
      failed: 'Login failed',
    },
    dashboard: {
      morning: 'Good morning', afternoon: 'Good afternoon', evening: 'Good evening',
      there: 'there',
      sub: "Here's what's on your plate today",
      newTask: 'New Task',
      open: 'Open', inProgress: 'In Progress', done: 'Done', critical: 'Critical',
      recentTasks: 'Recent Tasks',
      empty: 'No tasks yet. Create your first one!',
      projects: 'Projects', myTasks: 'My Tasks',
      noProjects: 'No projects yet.',
      subtasksWidget: 'Subtasks', commentsWidget: 'Recent Comments',
      noSubtasks: 'No subtasks yet.', noComments: 'No comments yet.', noRequests: 'No pending requests.',
      dragHint: 'Drag to rearrange widgets', addWidget: 'Add widget', hideWidget: 'Hide widget',
      noWidgets: 'All widgets hidden. Add one above.',
      paneEmpty: 'No tasks to show.',
      progress: 'Progress', allDone: 'All done',
      newInProject: 'New in project', selectHint: 'Pick a project to see its tasks',
    },
    tasks: {
      myTitle: 'My Tasks', teamTitle: 'Team Tasks',
      mySub: 'Tasks assigned to or created by you', teamSub: 'All tasks visible to your team',
      newTask: 'New Task',
      allUrgency: 'All urgency', allProjects: 'All projects',
      empty: 'No tasks found.',
      archiveConfirm: 'Archive "{title}"? It will move to the archive.',
    },
    taskForm: {
      newTask: 'New Task', editTask: 'Edit Task',
      title: 'Title', titlePlaceholder: 'Task title',
      description: 'Description', descriptionPlaceholder: 'Optional details…',
      urgency: 'Urgency', status: 'Status', project: 'Project', dueDate: 'Due date',
      visibility: 'Visibility',
      shared: '🌐 Shared (team sees this)', private: '🔒 Private (only you + assignee)',
      assignTo: 'Assign to', unassigned: '— Unassigned —',
      linkClient: 'Link to client',
      privateProjectLock: 'Tasks in a private project are always private — visible only to project members',
      createTask: 'Create task', saveFailed: 'Save failed',
    },
    taskCard: { private: 'Private', markDone: 'Mark as done', reopen: 'Reopen', archive: 'Archive' },
    subtasks: {
      toggle: 'Subtasks', titleCol: 'Subtask', titlePlaceholder: 'Subtask name',
      col: 'Column', addColumn: 'Add column', removeColumn: 'Delete column', newColumn: 'New column',
      removeColumnConfirm: 'Delete the column “{label}”?',
      addRow: 'Add', removeRow: 'Delete', addPlaceholder: 'New subtask…', empty: 'No subtasks yet',
    },
    comments: {
      title: 'Comments', empty: 'No comments yet',
      placeholder: 'Write a comment…', send: 'Send', closed: 'This task is completed — commenting is closed.',
    },
    export: {
      task: 'Task', project: 'Project', assignee: 'Assignee',
      status: 'Status', urgency: 'Urgency', hours: 'Hours', due: 'Due date',
    },
    timer: { start: 'Start timer', stop: 'Stop timer', running: 'Running now' },
    urgency: { low: 'Low', normal: 'Normal', high: 'High', critical: 'Critical' },
    status: { open: 'Open', in_progress: 'In Progress', done: 'Done' },
    projects: {
      title: 'Projects', newProject: 'New Project', editProject: 'Edit Project',
      empty: 'No projects yet.',
      name: 'Name', description: 'Description', color: 'Color', visibility: 'Visibility',
      shared: 'Shared (team sees this)', private: 'Private (only you)',
      sharedBadge: 'Shared', privateBadge: 'Private',
      taskCountOne: 'open task', taskCountMany: 'open tasks',
      noTasks: 'No tasks in this project', dragHint: 'Drag to reorder or move between projects',
      viewTasks: 'View tasks', archiveTitle: 'Archive project',
      archiveConfirm: 'Archive project "{name}"? It will no longer appear in the project list.',
      members: 'Project members', addMember: 'Add', remove: 'Remove',
      noMembers: 'No members yet', selectUser: '— Select user —',
      membersHint: 'Members can see the project and create tasks in it',
      saveFirst: 'Save the project first to add members',
      pricing: 'Pricing', pricingNone: 'No pricing', pricingFixed: 'Fixed price', pricingHourly: 'Per hour',
      ratePlaceholder: 'Hourly rate', totalPlaceholder: 'Total price',
      clients: 'Project clients', clientsHint: 'Assigned clients can see the project’s tasks and hours',
      noClients: 'No clients assigned', selectClient: '— Select client —', addClientBtn: 'Add',
    },
    archive: {
      title: 'Archive', sub: 'All archived tasks — nothing is permanently deleted',
      tasks: 'Tasks', projects: 'Projects',
      noTasks: 'No archived tasks.', noProjects: 'No archived projects.',
      archivedOn: 'Archived',
      restore: 'Restore', restoreConfirm: 'Restore "{title}" from the archive?',
    },
    teamPage: {
      title: 'Team', sub: 'Developers and shared projects in your workspace',
      developers: 'Developers', projects: 'Shared projects',
      noProjects: 'No shared projects', tasksCount: 'open tasks',
    },
    clients: {
      title: 'Clients', sub: 'External clients who can view tasks shared with them',
      addClient: 'Add Client', editClient: 'Edit Client',
      name: 'Name', username: 'Username', status: 'Status', projects: 'Projects',
      searchPh: 'Search by name or project…',
      active: 'Active', inactive: 'Inactive',
      activate: 'Activate', deactivate: 'Deactivate',
      empty: 'No external clients yet.',
      fullName: 'Full name', usernamePlaceholder: 'no spaces, used to log in',
      newPassword: 'New password (leave blank to keep)', passwordLabel: 'Password',
      passwordPlaceholder: 'min 8 characters',
      toggleConfirm: '{verb} {name}?',
    },
  },
}
